import type { IconProps } from "./icon-types";

/**
 * 로딩 스피너 글리프(8-spoke). 회전 애니메이션은 `Spinner` 컴포넌트가 얹는다 — 정적 글리프.
 *
 * `react-icons/lu`의 `LuLoader`(Lucide `loader`)를 c6 아이콘 세트 톤·그리드에 맞춰 인라인 재현.
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘). 24 그리드 / stroke 기반.
 */
export const LoaderIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 2v4" />
    <path d="m16.2 7.8 2.9-2.9" />
    <path d="M18 12h4" />
    <path d="m16.2 16.2 2.9 2.9" />
    <path d="M12 18v4" />
    <path d="m4.9 19.1 2.9-2.9" />
    <path d="M2 12h4" />
    <path d="m4.9 4.9 2.9 2.9" />
  </svg>
);
